import type { ReactNode } from 'react';

import classNames from 'classnames';

import styles from './FooterLayout.module.css';

import { Link, type LinkProps } from '../Link';
import { Nowrap } from '../Nowrap';
import { Text } from '../Text';

type FooterLinkItemProps = LinkProps & {
  className?: string;
  badge?: string | ReactNode;
};

/** A link item component for the footer layout */
export function FooterLinkItem({
  children,
  badge,
  className,
  ...linkProps
}: FooterLinkItemProps) {
  return (
    <li>
      <Text variant="heading-16" className={styles.linkItemLabel}>
        <Link
          baseColor="white"
          {...linkProps}
          className={classNames(styles.linkItem, className)}
        >
          <Nowrap>{children}</Nowrap>
        </Link>
        {typeof badge === 'string' ? (
          <Text
            as="span"
            variant="article-12"
            color="Kale1"
            fontStyle="italic"
            vSpacing="none"
            leftSpacing="sm"
          >
            <Nowrap>{badge}</Nowrap>
          </Text>
        ) : (
          badge
        )}
      </Text>
    </li>
  );
}
